import SimilarCommunities from '@sly/frontend/react/profile/components/SimilarCommunities';
import Carousel from '@sly/frontend/react/shared/components/Carousel';
import { ContentCommunitiesType } from 'sly/hubPage/components/HubPage/HubPage.types';

export interface DynamicCommunityProps {
  data: ContentCommunitiesType[];
}

export default function DynamicCommunity({
  data: communities,
}: DynamicCommunityProps) {
  if (!communities) {
    return null;
  }
  return (
    <div className=' w-full p-1 md:w-[680px] lg:w-[1040px]'>
      <Carousel itemsQty={communities.length} className='' innerClassName=''>
        <SimilarCommunities
          communities={communities.map((community) => ({
            ...community,
            id: community.slug,
            propInfo: community.info,
            gallery: {
              images: [{ src: community.background_image }],
            },
            propRatings: community.prop_stats,
          }))}
        />
      </Carousel>
    </div>
  );
}
